/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FieldRadioGroupOptionV1Dto } from './FieldRadioGroupOptionV1Dto';
export type FieldRadioGroupV1Dto = {
  /**
   * UUID of the document the field belongs to
   */
  document_id: string;
  /**
   * ID of the field
   */
  id: string;
  /**
   * Name of the field
   */
  name?: string | null;
  /**
   * Page number the field is located on
   */
  page: number;
  /**
   * UUID of the signer the field is assigned to
   */
  signer_id: string;
  /**
   * Type of the field
   */
  type: FieldRadioGroupV1Dto.type;
  /**
   * Whether the radio group is optional
   */
  optional: boolean;
  /**
   * Options within the radio group
   */
  radios: Array<FieldRadioGroupOptionV1Dto>;
};
export namespace FieldRadioGroupV1Dto {
  /**
   * Type of the field
   */
  export enum type {
    CHECKBOX = 'checkbox',
    MENTION = 'mention',
    RADIO_GROUP = 'radio_group',
    SIGNATURE = 'signature',
    TEXT = 'text',
  }
}
